export default __webpack_public_path__ + "static/media/locations.9a2e6384.png";